document.addEventListener('tea-ducks:cart-settled', () => {
  const drawer = document.querySelector('#cart-drawer');
  if (drawer?.hasAttribute('open')) drawer.setAttribute('aria-busy', 'false');
});

// Imported page headers share one presentation-only opening path. The native
// href remains the fallback; all reads/rendering still belong to the A service.
document.addEventListener('click', async (event) => {
  const link = event.target.closest('.td-moonlight-account a, [data-category-cart], [data-journal-cart]');
  if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
  const root = window.Shopify?.routes?.root || '/';
  if (new URL(link.href).pathname !== new URL(root + 'cart', location.origin).pathname) return;
  const safety = window.TeaDucksCartSafety;
  if (!document.querySelector('theme-drawer#cart-drawer') || !safety?.refresh) return;
  event.preventDefault();
  try {
    await safety.refresh();
  } catch (error) {
    // Open the protected error/retry state without permitting checkout.
    console.warn('[Tea Ducks] Cart verification requires attention.', error);
  }
  await customElements.whenDefined('theme-drawer');
  document.querySelector('theme-drawer#cart-drawer')?.open();
});
